function BrokingValue() {
  return (
    <section className="broking-value">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Our broking proposition</div>
          <h2>
            <span className="intro-title-line">Advice that continues</span>
            <span className="intro-title-line">beyond placement.</span>
          </h2>
          <p>WillMars combines portfolio intelligence, local market understanding and international relationships to build reinsurance solutions around each client’s objectives. Our role continues from early analysis through negotiation, documentation, claims and renewal.</p>
        </div>
        <div className="value-grid">
          <article className="value-card">
            <span>01 · DIAGNOSE</span>
            <h3>Portfolio intelligence</h3>
            <p>We examine exposure, loss experience, accumulation and existing protections to identify priorities before approaching the market.</p>
          </article>
          <article className="value-card">
            <span>02 · DESIGN</span>
            <h3>Market strategy</h3>
            <p>We align structure, retention and capacity with suitable markets, considering appetite, financial strength and execution capability.</p>
          </article>
          <article className="value-card">
            <span>03 · DELIVER</span>
            <h3>Placement execution</h3>
            <p>Clear submissions, disciplined negotiation and timely documentation support confident decisions and dependable programme delivery.</p>
          </article>
          <article className="value-card">
            <span>04 · SUPPORT</span>
            <h3>Claims continuity</h3>
            <p>Our involvement carries into notifications, supporting documents, market coordination and renewal learning when claims occur.</p>
          </article>
        </div>
      </div>
    </section>
  )
}

export default BrokingValue
